import { Link } from "react-router-dom"
import IWebsite from "../../interfaces/IWebsite"

interface IProps {
    website: IWebsite,
    onCreateNewSource(): void
}

export const NoSourcesScreen = (props: IProps) => {
    const website = props.website;

    return (
        <div className="card">
            <div className="card-body text-center">
                <div className="py-5">
                    <div className="d-flex justify-content-center mb-0 mt-2">
                        <h5>Vytvářejte obsah z JSON, XML nebo CSV</h5>
                    </div>

                    <p>Jakékoli data proměňte do webu.</p>
                    <div className="text-center mt-2">
                        <button
                            onClick={props.onCreateNewSource.bind(this)}
                            className="btn btn-primary mt-2">
                            Přidat nový zdroj
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}